/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React from 'react';

import {
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableBody,
  Paper,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  formatDateWithYear,
  levelToCEFR,
  typeOfLanguageFormatting,
  typeOfTrainingFormatting,
} from '../../../helpers/utils';

const useStyles = makeStyles({
  root: {
    marginTop: '30px',
    marginBottom: '30px',
  },
});

const CourseInformations = ({ courseInfos }) => {
  const classes = useStyles();

  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableBody>
          <TableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell align="left" variant="head">Société</TableCell>
            <TableCell align="left">{courseInfos.company.name ? courseInfos.company.name : ''}</TableCell>
          </TableRow>
          <TableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell align="left" variant="head">Niveau</TableCell>
            <TableCell align="left">{courseInfos.level ? levelToCEFR(courseInfos.level) : ''}</TableCell>
          </TableRow>
          <TableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell align="left" variant="head">Intitulé de la formation</TableCell>
            <TableCell align="left">
              {courseInfos.name ? courseInfos.name : ''}
            </TableCell>
          </TableRow>
          <TableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell align="left" variant="head">Détails de la formation</TableCell>
            <TableCell align="left">
              Type de langage:
              {' '}
              {courseInfos.coursePlan?.typeoflanguage ? typeOfLanguageFormatting(courseInfos.coursePlan?.typeoflanguage) : 'n/a'}
              <br />
              Type d&apos;entraînement:
              {courseInfos.coursePlan?.typeoftraining?.map((item, index) => (
                <>
                  {' '}
                  {courseInfos.coursePlan?.typeoftraining
                    ? typeOfTrainingFormatting(item)
                    : 'n/a'}
                  {courseInfos.coursePlan.typeoftraining.length === index + 1
                    ? ''
                    : ','}
                </>
              ))}
            </TableCell>
          </TableRow>
          <TableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell align="left" variant="head">Durée</TableCell>
            <TableCell align="left">
              {courseInfos.coursePlan.duration ? courseInfos.coursePlan.duration : 0}
              h
            </TableCell>
          </TableRow>
          <TableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell align="left" variant="head">Date de début</TableCell>
            <TableCell align="left">{courseInfos.coursePlan.beginDate ? formatDateWithYear(courseInfos.coursePlan.beginDate) : ''}</TableCell>
          </TableRow>
          <TableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell align="left" variant="head">Date de fin</TableCell>
            <TableCell align="left">{courseInfos.coursePlan.endDate ? formatDateWithYear(courseInfos.coursePlan.endDate) : ''}</TableCell>
          </TableRow>
          <TableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell align="left" variant="head">Formateur</TableCell>
            {courseInfos.idTeachers.length > 0
              ? (
                <TableCell align="left">
                  {courseInfos.idTeachers.map((teacher, index) => (
                    `${teacher.name} ${teacher.firstname}${index === courseInfos.idTeachers.length - 1 ? '' : ', '}`
                  ))}
                </TableCell>
              )
              : (
                <TableCell align="left">
                  No teachers
                </TableCell>
              )}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CourseInformations;
